module.exports = __webpack_public_path__ + "static/media/plusIcon.9223303f.svg";